import repository from '@/utils/repository';

const resource = '/move';

export default {
    search: (data) => {
        return repository.post(`${resource}/postCommonOrder008Info`, {
            ...data
        });
    }
};
